<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="兑奖人ID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['openId']" disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item
          label="兑奖人姓名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['name']" disabled="disabled" />
        </a-form-item>
        <a-form-item
          label="兑奖人电话"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['phone']" disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item
          label="兑奖人地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['address']" disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item
          label="奖品名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['prizeName']" disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item
          label="奖品ID"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['prizeId']" disabled="disabled" />
        </a-form-item>
        <a-form-item
          label="快递单号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-if="showTracking"
        >
          <a-input
            v-decorator="['trackingNumber']"
            placeholder="请输入快递单号"
          />
        </a-form-item>
        <!--<a-form-item label="处理状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch checked-children="已处理" un-checked-children="未处理" v-decorator="['isDeal']" v-show="Ok" default-checked/>
          <a-switch checked-children="已处理" un-checked-children="未处理" v-decorator="['isDeal']" v-show="unOk"/>
        </a-form-item>-->
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { getAction, httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';

export default {
  name: 'ExchangePrizeModal',
  components: {
    JDate,
    JImageUpload
  },
  props: {},
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      disableSubmit: false,
      showTracking: false,
      showDeal: false,
      model: {},
      /*Ok: false,
        unOk: false,*/
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        //add: process.env.VUE_APP_CMS_MARKETING + "/integral/config/add",
        edit: process.env.VUE_APP_CMS_MARKETING + '/exchange/prize/edit'
      }
    };
  },
  created() {},
  watch: {
    model(newVal, oldVal) {
      this.reloadDataSource();
    }
  },
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'openId',
            'name',
            'phone',
            'address',
            'prizeName',
            'prizeId',
            'isDeal',
            'trackingNumber'
          )
        );
      });

      console.log('name:' + this.model.name);

      if (this.model.address === null || this.model.address === '') {
        this.showTracking = false;
      } else {
        this.showTracking = true;
      }

      /*if (this.model.name != null && this.model.phone.length != null && this.model.address.length != null){
          this.showDeal = true;
        }*/
      /*if (this.model.isDeal === 'true'){
          this.Ok = true;
          this.unOk = false;
          console.log("usedStatus::::" + this.model.isDeal);
          console.log("Ok::::" + this.Ok);
          console.log("unOk::::" + this.unOk);
        }else {
          this.unOk = true;
          this.Ok = false;
          console.log("usedStatus::::" + this.model.isDeal);
          console.log("Ok::::" + this.Ok);
          console.log("unOk::::" + this.unOk);
        }*/
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);

          console.log(formData.name);
          if (formData.name === null || formData.name === '') {
            that.confirmLoading = false;
            that.close();
            return;
          }

          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'openId',
          'name',
          'phone',
          'address',
          'prizeName',
          'prizeId',
          'isDeal',
          'trackingNumber'
        )
      );
    },
    switchHandle(e) {
      console.log('switch 发生 change 事件，携带值为', e);
    }
  }
};
</script>
